import { render, staticRenderFns } from "./DynamicQrCodeIndex.vue?vue&type=template&id=65b3b4d5"
import script from "./DynamicQrCodeIndex.vue?vue&type=script&lang=js"
export * from "./DynamicQrCodeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports